// Shared filter, search, pagination, and row-toggle logic for email records pages.
// Call window.EmailRecordsFilter.init(prefix, perPage, buildRowFn) from a page-level
// inline script after embedding the JSON data and filter HTML via the shared partial.
// window.EmailRecordsFilter.esc(str) and .statusBadge(send_status, display) are available
// to page-level buildRow functions.
window.EmailRecordsFilter = {
  esc: function (str) {
    return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  },

  statusBadge: function (send_status, status_display) {
    var dotColors = {
      delivered:  'bg-green-400',
      queued:     'bg-amber-400',
      failed:     'bg-red-400',
      error:      'bg-red-400',
      bounced:    'bg-orange-400',
      processing: 'bg-blue-400',
      skipped:    'bg-slate-300',
      dropped:    'bg-slate-300'
    };
    var dot = '<span class="inline-block w-1.5 h-1.5 rounded-full flex-shrink-0 ' + (dotColors[send_status] || 'bg-slate-300') + '"></span>';
    return '<span class="inline-flex items-center gap-1.5 text-xs text-slate-500 whitespace-nowrap">' + dot + window.EmailRecordsFilter.esc(status_display || send_status || '') + '</span>';
  },

  init: function (prefix, perPage, buildRow) {
    var p           = prefix;
    var dataEl      = document.getElementById(p + '-records-data');
    var ALL_RECORDS = dataEl ? JSON.parse(dataEl.textContent) : [];

    var searchInput  = document.getElementById(p + '-search-input');
    var reasonFilter = document.getElementById(p + '-reason-filter');
    var statusFilter = document.getElementById(p + '-status-filter');
    var clearBtn     = document.getElementById(p + '-clear-btn');
    var visibleCount = document.getElementById(p + '-visible-count');
    var noResults    = document.getElementById(p + '-no-results');
    var recordsList  = document.getElementById(p + '-records-list');
    var paginationEl = document.getElementById(p + '-pagination');

    var filteredRecords = ALL_RECORDS.slice();
    var currentPage     = 1;

    // Delegate row-toggle clicks so buildRow doesn't need onclick attributes.
    if (recordsList) {
      recordsList.addEventListener('click', function (e) {
        var btn = e.target.closest('.' + p + '-toggle');
        if (btn) toggleRow(btn);
      });
    }

    function toggleRow(btn) {
      var row     = btn.closest('.' + p + '-record-row');
      var details = row && row.querySelector('.' + p + '-details');
      var chevron = btn.querySelector('.' + p + '-chevron');
      if (!row || !details || !chevron) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      details.classList.toggle('hidden', open);
      chevron.style.transform = open ? '' : 'rotate(180deg)';
    }

    window.toggleEmailRecordRow = toggleRow;

    function renderPagination(total, page, totalPages) {
      if (!paginationEl) return;
      if (totalPages <= 1) { paginationEl.innerHTML = ''; return; }
      var prev = page > 1
        ? '<button id="' + p + '-prev-btn" class="px-4 py-2 text-sm text-slate-500 hover:text-slate-700 transition-colors duration-150">← Previous</button>'
        : '';
      var next = page < totalPages
        ? '<button id="' + p + '-next-btn" class="px-4 py-2 text-sm text-[#491363] hover:text-purple-900 transition-colors duration-150">Next →</button>'
        : '';
      paginationEl.innerHTML = [
        '<nav class="flex items-center justify-between border-t border-slate-100 pt-4 mt-1" aria-label="Pagination">',
          '<p class="text-xs text-slate-400">Page ', page, ' of ', totalPages, ' &mdash; ', total, ' records</p>',
          '<div class="flex gap-1">', prev, next, '</div>',
        '</nav>'
      ].join('');
      var prevBtn = document.getElementById(p + '-prev-btn');
      var nextBtn = document.getElementById(p + '-next-btn');
      if (prevBtn) prevBtn.addEventListener('click', function () { currentPage--; render(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { currentPage++; render(); });
    }

    function render() {
      if (ALL_RECORDS.length === 0) return;
      var totalPages  = Math.max(Math.ceil(filteredRecords.length / perPage), 1);
      if (currentPage > totalPages) currentPage = totalPages;
      var start       = (currentPage - 1) * perPage;
      var pageRecords = filteredRecords.slice(start, start + perPage);
      if (visibleCount) visibleCount.textContent = filteredRecords.length;
      if (pageRecords.length === 0) {
        recordsList.innerHTML = '';
        if (recordsList) recordsList.classList.add('hidden');
        if (noResults) noResults.classList.remove('hidden');
      } else {
        recordsList.innerHTML = pageRecords.map(buildRow).join('');
        if (recordsList) recordsList.classList.remove('hidden');
        if (noResults) noResults.classList.add('hidden');
      }
      renderPagination(filteredRecords.length, currentPage, totalPages);
    }

    function anyFilterActive() {
      return (searchInput && searchInput.value.trim()) ||
             (reasonFilter && reasonFilter.value) ||
             (statusFilter && statusFilter.value);
    }

    function applyFilters() {
      var term   = searchInput ? searchInput.value.trim().toLowerCase() : '';
      var reason = reasonFilter ? reasonFilter.value : '';
      var status = statusFilter ? statusFilter.value : '';
      filteredRecords = ALL_RECORDS.filter(function (r) {
        if (term   && (r.data_search || '').indexOf(term) === -1) return false;
        if (reason && r.reason      !== reason) return false;
        if (status && r.send_status !== status) return false;
        return true;
      });
      currentPage = 1;
      if (clearBtn) clearBtn.classList.toggle('hidden', !anyFilterActive());
      render();
    }

    if (searchInput)  searchInput.addEventListener('input',  applyFilters);
    if (reasonFilter) reasonFilter.addEventListener('change', applyFilters);
    if (statusFilter) statusFilter.addEventListener('change', applyFilters);
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (searchInput)  searchInput.value  = '';
        if (reasonFilter) reasonFilter.value = '';
        if (statusFilter) statusFilter.value = '';
        applyFilters();
      });
    }

    render();
  }
};
